/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PatchOrdersOrderIdArchiveMutationResponse, PatchOrdersOrderIdArchivePathParams, PatchOrdersOrderIdArchive400 } from "../entities/PatchOrdersOrderIdArchive";

function getPatchOrdersOrderIdArchiveUrl(order_id: PatchOrdersOrderIdArchivePathParams["order_id"]) {
  const res = { method: 'PATCH', url: `/orders/${order_id}/archive` as const }  
  return res
}

/**
 * @description Архивирование заказа
 * @summary Архивирование
 * {@link /orders/:order_id/archive}
 */
export async function patchOrdersOrderIdArchive(order_id: PatchOrdersOrderIdArchivePathParams["order_id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PatchOrdersOrderIdArchiveMutationResponse, ResponseErrorConfig<PatchOrdersOrderIdArchive400>, unknown>({ method : "PATCH", url : getPatchOrdersOrderIdArchiveUrl(order_id).url.toString(), ... requestConfig })  
  return res.data
}